/**
 * @return {{feature: string, click: string}}
 */
export const cardListPlaylistClick = () => ({
  feature: 'playlist',
  click: 'contenu_playlist',
});
